import React from 'react';
import AddEditTemplateForm from 'ui-component/Template/AddEditTemplateForm';

function AddTemplate () {
  return (
    <div>
      <AddEditTemplateForm title="Add Template" />
    </div>
  )
}

export default  AddTemplate;